<template>
  
  <div class="container">
  
    <Cabecera></Cabecera>
    <b-breadcrumb>
    <b-breadcrumb-item href="#"><router-link to="/">Inicio</router-link></b-breadcrumb-item>
    <b-breadcrumb-item href="#"><router-link to="/menuinicial">Inicio Usuario </router-link></b-breadcrumb-item>
    <b-breadcrumb-item href="#"><router-link to="/SalidaCarnePorcino">Registro de salida de carne porcino</router-link></b-breadcrumb-item>
    
  </b-breadcrumb>
  <div>
  <Menu/>
    
  <b-card>
    
   <br>

        
          <span class="card-title">Registro de salida de carne porcino</span>
          <form id="formPeso" autocomplete="off" @submit.prevent="editar" enctype="multipart/form-data">
            <input type="text" placeholder="Unidad" :value=unidad required disabled>
             <input type="date" name="fecharegistro" id="fecharegistro" placeholder="Fecha" v-on:click=usuario() required>
             <b-form-select v-model="selected2" class="mb-3" required>
                <template v-slot:first>
        <b-form-select-option :value="null" disabled  >-- Selecciona especie --</b-form-select-option>
      </template>
      
      <b-form-select-option value="Porcino">Porcino</b-form-select-option>
     
    </b-form-select>
<input type="number" name="papeleta" id="papeleta" placeholder="Papeleta de salida de carne"  v-on:click=ajax2()>



       <vue-good-table
   :columns="columns2"
     :rows="rows2"
     @on-cell-click="onCellClick2"
     :select-options="{ enabled: false }"
      
     :pagination-options="{
       enabled:true,
      
       mode:'remote',
       perPage:50,
       
     }"
     :search-options="{
       enabled:false,
       trigger:'enter',
       placeholder:'Buscar'
     }"
   >
     <template slot="table-row" slot-scope="props">
          
    <span v-if="props.column.field == 'eliminar'">
       
       <b-button variant='danger' >Eliminar</b-button>
     
    </span>
    <span v-else>
      {{props.formattedRow[props.column.field]}}
    </span>
  </template>
   </vue-good-table>

             
       <div class="file-field input-field">
                <div class="btn">
                <span>Evidencia</span>
                <input type="file" name="evidencia">
                </div>
                <div class="file-path-wrapper">
                <input class="file-path validate" type="text">
                </div>
            </div>      

            <input type="text" name="supervisorForma" id="supervisorForma"  placeholder="Supervisor" > 
            <input type="text" name="cargadorForma" id="cargadorForma" placeholder="Cargador" > 
            <input type="text" name="recibeForma" id="recibeForma" placeholder="Recibe" > 
            <input type="text" name="placasForma" id="placasForma" placeholder="Placas del vehículo" > 
            <input type="text" name="destinoForma" id="destinoForma" placeholder="Destino de la carne" > 
            <input type="number" name="limpiezaForma" id="limpiezaForma"  placeholder="¿Vehículo Limpio? (1=sí, 2=no"> 
            <input type="number" name="sanitizacionForma" id="sanitizacionForma" placeholder="¿Vehículo sanitizado? (1=sí, 2=no" > 
            <input type="number" name="cerradoForma" id="cerradoForma" placeholder="¿Vehículo cerrado? (1=sí, 2=no" > 
            <input type="text" name="ticketForma" id="ticketForma" placeholder="Recibo de pago" > 

            
           
    
           
            
    
            <input type="hidden" name="unidadForma" id="unidadForma" :value=unidad> 
            
             <input type="hidden" name="usuarioForma" id="usuarioForma" :value=usuariolocal>
             <input type="hidden" name="especieForma" id="especieForma" :value=selected2>
             
             <input type="hidden" name="idForma" id="idForma" :value=idActual>
             <input type="hidden" name="serieForma" id="serieForma" :value=serie>
             <input type="hidden" name="canalForma" id="canalForma" :value=canal>
             <input type="hidden" name="seccionForma" id="seccionForma" :value=seccion>
            
<div class="card-action">

                        <input type="submit" value="Registrar" class="btn btn-outline-success" required >
                           
        </div>
            </form>
       
    <b-card-body class="text-center">
      <b-card-title>Pantalla de inicio</b-card-title>

      <b-card-text>
       <div>
    <h5>Listado del día <input width="4" type="date" name="fechadia" id="fechadia" placeholder="Fecha" v-on:click=ajax() >
<p id="datetime"></p>
    </h5>
   <vue-good-table
   :columns="columns"
     :rows="rows"
     @on-cell-click="onCellClick"
     :select-options="{ enabled: false }"
      
     :pagination-options="{
       enabled:true,
      
       mode:'remote',
       perPage:350,
       position:'top',
       perPageDropdown:[10,50,100],
       nextLabel:'Siguiente',
       PrevLabel:'Anterior',
       rowsPerPageLabel:'Filas por página',
       ofLabel:'de'
     }"
     :search-options="{
       enabled:true,
       trigger:'enter',
       placeholder:'Buscar'
     }"
   >
     <template slot="table-row" slot-scope="props">
          
    <span v-if="props.formattedRow[props.column.field] == 1 && props.column.field != 'canal'">
       
       <b-button variant='danger' >Agregar</b-button>
     
    </span>
    <span v-else-if="props.column.field == 'chaleco1'">
       
       {{props.formattedRow['fechasalidachaleco1']}}
     
    </span>
    <span v-else-if="props.column.field == 'chaleco2'">
       
       {{props.formattedRow['fechasalidachaleco2']}}
     
    </span>
    <span v-else-if="props.column.field == 'pierna1'">
       
       {{props.formattedRow['fechasalidapierna1']}}
     
    </span>
    <span v-else-if="props.column.field == 'pierna2'">
       
       {{props.formattedRow['fechasalidapierna2']}}
     
    </span>
    <span v-else>
      {{props.formattedRow[props.column.field]}}
    </span>
  </template>
   </vue-good-table>
</div>
      </b-card-text>

      <b-button variant="primary">Go somewhere</b-button>
    </b-card-body>
  </b-card>
</div>

    
  </div>
</template>

<script>
import Cabecera from './Cabecera' //v-on:keyup.enter="onEnter"
import Menu from './Menu'
import axios from 'axios'
import swal from 'sweetalert'
import sesion from '../mixins/sesion'

import eliminarDecomisos from '../mixins/eliminarDecomisos'
import {mapState, mapMutations, mapActions, mapGetters} from 'vuex'
export default {
  name: 'SalidaCarnePorcino',  
  data () {
    return {
        value:null,
      msg: 'Número de arete',
      inventarioCanales:{},
      usuariolocal:'',
      fotolocal:'',
      unidad:'',
        fecha1:'',
        fecha2:'',
        serie:'',
        canal:'',
        seccion:'',
selected: null,
selected2: 'Porcino',
selectedCanal:null,
//Datos del checkbox
      columns:[
        {
          label:'Serie',
          field:'serie'
        },
        {
          label:'Canal',
          field:'canal'
        },
        {
          label:'Fecha de sacrificio',
          field:'fecha',
          type:'date',
          dateInputFormat:'yyyy-mm-dd',
          dateOutputFormat:'yyyy-mm-dd'
        },
        {
          label:'Canal',
          field:'todo'
        },
        {
          label:'Fecha',
          field:'fechasalidatodo',
          type:'date',
          dateInputFormat:'yyyy-mm-dd',
          dateOutputFormat:'yyyy-mm-dd',
          hidden: true
        },
        
      ],
      rows:[

      ],

      columns2:[
        {
          label:'Serie',
          field:'serie'
        },
        {
          label:'Canal',
          field:'canal'
        },
        {
          label:'Fecha de sacrificio',
          field:'fecha',
          type:'date',
          dateInputFormat:'yyyy-mm-dd',
          dateOutputFormat:'yyyy-mm-dd'
        },
        {
          label:'Sección',
          field:'seccion'
        },
        {
          label:'Eliminar',
          field:'eliminar'
        },
        
      ],
      rows2:[

      ],
    }
    },
  
  computed:{
      ...mapState(['usuarioActual','idActual','fotoActual'])
  },
  methods:{
      
      getInventario(){
          const unidadInv = this.unidad
            
            axios.get('https://micomidasegura.mx/comidaSegura/api/crud/getInventario.php?unidad='+ unidadInv)
            
                .then(response=>{
                   
                    this.inventarioCanales=response.data
                    
                })
      },
    getId(){
           this.usuario()

            const id = document.getElementById("usuarioForma").value
            
            axios.get('https://micomidasegura.mx/comidaSegura/api/crud/getPerfilUsuario.php?id='+ id)
            
                .then(response=>{
                   
                    this.unidad = response.data.unidad
                    this.usuariolocal=response.data.email
                    
                })        
        },

     onCellClick(params) {
         if(params.column.field=="todo"){   //que sea solo en esas columnas y que se refresque
         this.serie=params.row.serie
         this.canal=params.row.canal
         this.seccion="todo"
         if(document.getElementById('fecharegistro').value==''){
             swal('Favor de seleccionar fecha')
         }
         else if(document.getElementById('papeleta').value==''){
             swal('Favor registrar papeleta')
         }
         else{
         swal({
            title:'Seguro que deseas agregar el registro',
            text:'',
            icon:'warning',
            buttons:true,
            dangerMode:true,
        })
        .then((aceptar)=>{
            if(aceptar){
            const form=document.getElementById('formPeso')
                axios.post('https://micomidasegura.mx/comidaSegura/api/crud/registrarPapeletaSalidaCarne.php',new FormData(form))
                .then(res=>{
                    this.respuesta = res.data
                    if (res.data == 'success') {
                        this.ajax()
         this.ajax2()
                       //('Se registro el decomiso con éxito')
                       //location.reload()
                        //this.$router.push('/inicio')
                    } else {
                        //swal('El decomiso no pudo ser registrado'+res.data)
                    }
                })
            }else{
                return false;
            }
        })
         
         
         this.ajax()
         this.ajax2()
         }
         }
        //this.ajax()
         //
   // alert (params.row.id) // params.row - row object   /// 
    // params.pageIndex - index of this row on the current page.
    // params.selected - if selection is enabled this argument 
    // indicates selected or not
    // params.event - click event
  },
  onCellClick2(params) {
         if(params.column.field=="eliminar"){   //que sea solo en esas columnas y que se refresque
         this.serie=params.row.serie
         this.canal=params.row.canal
         this.seccion=params.row.seccion
         
         swal({
            title:'Seguro que deseas eliminar el registro',
            text:'',
            icon:'warning',
            buttons:true,
            dangerMode:true,
        })
        .then((aceptar)=>{
            if(aceptar){
            const form=document.getElementById('formPeso')
                axios.post('https://micomidasegura.mx/comidaSegura/api/crud/eliminarSeccionPapeleta.php',new FormData(form))
                .then(res=>{
                    this.respuesta = res.data
                    if (res.data == 'success') {
                        this.ajax()
         this.ajax2()
                      swal('Se registro fue eliminado')
                       //location.reload()
                        //this.$router.push('/inicio')
                    } else {
                        swal('El registro no fue eliminado')
                    }
                })
            }else{
                return false;
            }
        })
         this.ajax()
         this.ajax2()
         
         }
  },
      /*onEnter: function() {
      swal("Mensaje de enter")
    },*/
    fecha(){
        var dt = new Date();
    document.getElementById("datetime").innerHTML = ((dt.getFullYear() +"-"+ (("0"+(dt.getMonth()+1)).slice(-2)) 
    +"-"+ ("0"+dt.getDate()).slice(-2)));
    },
    ajax(){
     //const fecha = JSON.parse(document.getElementsByName('fecharegistro').value)
     this.getId()
    const fecha = document.getElementById("fechadia").value
     const unidadquery=this.unidad
      axios.get('https://micomidasegura.mx/comidaSegura/api/crud/getInventario.php?fecha='+fecha+'&unidad='+unidadquery+'&especie=Porcino')
      .then(response=>{
        this.rows=response.data
      })

    },

    ajax2(){
     //const fecha = JSON.parse(document.getElementsByName('fecharegistro').value)
     this.getId()
    
     const folio = document.getElementById("papeleta").value
     const unidadquery=this.unidad
     //swal('valores'+unidadquery+folio)
      axios.get('https://micomidasegura.mx/comidaSegura/api/crud/getPapeleta.php?folio='+folio+'&unidad='+unidadquery)
      .then(response=>{
        this.rows2=response.data
      })

    },
    usuario(){
        this.fecha()
     //const fecha = JSON.parse(document.getElementsByName('fecharegistro').value)
     var yourString = this.$localStorage.get('token');
     var result = yourString.slice(1,-1);
     //this.usuariolocal= result
     //const tok=this.usuariolocal
     const tok=result
      axios.get('https://micomidasegura.mx/comidaSegura/api/crud/getUserData2.php?token='+tok)
      .then(response=>{
       
        this.usuariolocal=response.data.email
        this.unidad=response.data.unidad
        this.perfil=response.data.perfil
      })

    },
    ticketIncremento(){
       // document.getElementById('canal').value=document.getElementById('canal').value++
    this.value=Number(this.value)+1
    },
    editar(){
        document.getElementById('formPeso').empty
        this.getId()
        this.ajax2()
           
            this.usuario()
            
             const form=document.getElementById('formPeso')
                axios.post('https://micomidasegura.mx/comidaSegura/api/crud/updatePapeletaSalida.php',new FormData(form))
                .then(res=>{
                    this.respuesta = res.data
                    if (res.data == 'success') {
                       // this.ticketIncremento()
                      
                       swal('Se registro el decomiso con éxito'+res.data)
                       //location.reload()
                        //this.$router.push('/inicio')
                        
                    } else {
                        swal('El decomiso no pudo ser registrado'+res.data)
                    }
                })
        },
        direccionamiento(){
            if (this.respuesta=='success') {
                this.$router.push('/')
            } else {
                swal({
                    title:'No se pudo registrar',
                    icon: 'error'})  
            }
        },
  },
  created(){
    this.ajax()
    this.usuario()
   

  },
  components:{
    Cabecera,
    Menu
  },
  mixins:[sesion,eliminarDecomisos]
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/SalidaCarnePorcino.vue